module.exports = __webpack_public_path__ + "media/images/common/logo_coopaichi-b36de1e6c498c5a1ee3add6ddb5efac3.png";